import { useEffect, useState } from "react";
import {
  Button,
  CardHeader,
  Dialog,
  DialogContent,
  Grid,
  Loading,
  MenuItem,
  Select,
} from "../../../../components";
import { ImpressoraService } from "../../../../services";
import { responseErros } from "../../../../utils";

function ListagemImpressoras({ open, setOpen, configuracao, onChange, tipo }) {
  const [impressoras, setImpressoras] = useState([]);
  const [loading, setLoading] = useState(true);
  const impressoraService = new ImpressoraService();

  useEffect(() => {
    if (open) {
      buscarImpressoras();
    }
  }, [open]);

  const buscarImpressoras = async () => {
    setLoading(true);
    const result = await impressoraService.get();
    if (!result.isAxiosError) {
      setImpressoras(result.data);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  return (
    <Dialog
      maxWidth={"sm"}
      fullWidth
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogContent>
        <CardHeader
          title="Lista de Impressoras"
          action={
            <Button
              onClick={() => setOpen(!open)}
              variant="contained"
              color="padrao"
            >
              fechar
            </Button>
          }
        />
        <Grid sx={{ p: 1 }}>
          {tipo == "TERMICA" ? (
            <>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Select
                    id="impressoraTermica"
                    name="impressoraTermica"
                    value={configuracao?.impressoraTermica || ""}
                    label="Impressora Termica"
                    margin="normal"
                    onChange={onChange}
                    fullWidth
                  >
                    {impressoras.map((impressora, index) => (
                      <MenuItem
                        key={`${impressora}-${index}`}
                        value={impressora}
                      >
                        {impressora}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Grid>
            </>
          ) : (
            <>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Select
                    id="impressoraEtiqueta"
                    name="impressoraEtiqueta"
                    value={configuracao?.impressoraEtiqueta || ""}
                    label="Impressora de Etiquetas"
                    margin="normal"
                    onChange={onChange}
                    fullWidth
                  >
                    {impressoras.map((impressora, index) => (
                      <MenuItem
                        key={`${impressora}-${index}`}
                        value={impressora}
                      >
                        {impressora}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </DialogContent>
      <Loading loading={loading} />
    </Dialog>
  );
}

export default ListagemImpressoras;
